import classNames from "@calcom/ui/classNames";
import type { ReactNode } from "react";

const FLAGS: Record<string, { viewBox: string; shapes: ReactNode }> = {
  de: {
    viewBox: "0 0 5 3",
    shapes: (
      <>
        <rect width="5" height="1" fill="#000" />
        <rect y="1" width="5" height="1" fill="#D00" />
        <rect y="2" width="5" height="1" fill="#FFCE00" />
      </>
    ),
  },
  en: {
    viewBox: "0 0 60 30",
    shapes: (
      <>
        <rect width="60" height="30" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFF" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2" />
        <path d="M30,0 V30 M0,15 H60" stroke="#FFF" strokeWidth="10" />
        <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
      </>
    ),
  },
  pl: {
    viewBox: "0 0 8 5",
    shapes: (
      <>
        <rect width="8" height="5" fill="#FFF" />
        <rect y="2.5" width="8" height="2.5" fill="#DC143C" />
      </>
    ),
  },
};

/** Decorative only: the language code beside it is the label, so a language without a flag renders nothing. */
export function LanguageFlag({ locale, className }: { locale: string; className?: string }) {
  const flag = FLAGS[locale.split("-")[0].toLowerCase()];
  if (!flag) return null;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox={flag.viewBox}
      preserveAspectRatio="xMidYMid slice"
      className={classNames("h-[11px] w-4 shrink-0 rounded-[2px] ring-1 ring-black/10", className)}>
      {flag.shapes}
    </svg>
  );
}
